import { Component } from 'react';
import { connect } from 'react-redux';
import InterventionReportField from '../InterventionReportField';
import { clone } from '../../../utils'
import { getFieldVisibility, getFieldMandatory } from '../../../redux/intervention/interventionActions';
import { getStateAccessor } from '../../../lib/evaluateStringAsCodeHelper';
import { TYPING_TIMEOUT } from '../../../constants'
import CustomizedTextField from '../../Input/CustomizedTextField';
import { getCurrentFunctionName } from '../../../performanceModeManager';

class InterventionDecimalAndTextField extends Component {

    constructor(props) {
        super(props);
        this.state = {
            quantity: props.value.value_float,
            text: props.value.value_text,
            labelQuantity: "Quantité",
            textTypingTimeout: "",
            quantityTypingTimeout: "",
            timeout: TYPING_TIMEOUT,
        }
    }

    static getDerivedStateFromProps(props, state) {

        if (state.typedJustNow)
            return state;

        state.text = props.value.value_text;
        state.quantity = props.value.value_float;
        return state;
    }

    quantityChange(e) {
        let value = e.target.value;

        if (this.state.quantityTypingTimeout) {
            clearTimeout(this.state.quantityTypingTimeout);
        }

        this.setState({
            quantity: value,
            typedJustNow: true,
            quantityTypingTimeout: setTimeout(() => {

                let fieldValue = this.props.value;
                fieldValue.value_text = this.state.text;
                fieldValue.value_float = value;
                this.props.fieldValueChange(fieldValue);

                this.setState({
                    typedJustNow: false
                })
            }, this.state.timeout)
        });
    }

    textChange(fieldTypeId, fieldValue) {
        let value = fieldValue.value_text;

        this.setState({
            text: value,
            typedJustNow: true,
            textTypingTimeout: setTimeout(() => {
                let fieldValue = this.props.value;
                fieldValue.value_text = value;
                fieldValue.value_float = this.state.quantity;
                this.props.fieldValueChange(fieldValue);

                this.setState({
                    typedJustNow: false
                })
            }, this.state.timeout)
        });
    }

    onQuantityClick = ev => {
        const el = ev.target;
        if (document.activeElement !== el) {
            setTimeout(() => {
                if (el.select)
                    el.select();
            }, 0);
        }
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        let model = clone(this.props.model);
        model.value_type = "text";

        let stateAccessor = getStateAccessor(this.props);
        let visible = getFieldVisibility(this.props.blocs, this.props.blocTypes, this.props.blocId, model, stateAccessor);
        let required = getFieldMandatory(this.props.blocs, this.props.blocTypes, this.props.blocId, model, stateAccessor);

        return (
            <div className="row">
                <div className="col-lg-7 col-md-7 col-sm-7 col-7 without-side-padding">
                    <InterventionReportField value={this.state.text}
                        {...this.props} label={this.props.model.name} visible={visible}
                        className=" full_size control-margin-top" required={required}
                        model={model} blocId={this.props.blocId}
                        fieldValueChange={this.textChange.bind(this)}
                        blocType={this.props.blocType} />
                </div>
                <div className="offset-lg-2 offset-md-2 offset-sm-2 offset-2 col-lg-3 col-md-3 col-sm-3 col-3 without-side-padding">
                    <CustomizedTextField onChange={this.quantityChange.bind(this)} value={this.state.quantity}
                        {...this.props.inputProperties} label={this.state.labelQuantity} type="number" onMouseDown={this.onQuantityClick}
                        className={this.props.inputProperties.className + " full_size control-margin-top"} />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        loggedEmployee: state.loggedEmployee.loggedEmployee,
        fluidBottles: state.liquidBottles.myLiquidBottles,
        blocs: state.intervention.blocs,
        blocTypes: state.interventions.blocTypes,
        intervention: state.intervention.currentIntervention,
        sppFound: state.analysesRisques.sppFound,
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InterventionDecimalAndTextField);
